import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { ExclamationTriangleFill as Alert, Check, DashCircleFill as Cancel } from "react-bootstrap-icons";
import { setDialog } from '../store/api/GetAllProduct';
const ModalDialog = () => {
    const openDialog = useSelector(state => state.popup?.openDialog);
    const arrayBtn = openDialog.arrayBtn;
    const dispatch = useDispatch();
    const handleModal = () => {
        if (openDialog.okOperation !== undefined) {
            dispatch(openDialog.okOperation);
        }

        dispatch(setDialog({ status: 'hide' }));
    }


    return (
        <Modal show={openDialog.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle' style={{ display: 'inline-block', color: 'white', padding: '0.6rem 0.6rem' }}><Alert size={22} style={{ color: 'rgb(255 178 4)' }} />&nbsp;&nbsp;{openDialog.dialogTitle}</Modal.Header>
            <Modal.Body>
                <span>{openDialog.dialogText}</span>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "flex-start" }}>
                {arrayBtn && arrayBtn.includes("yes") && <Button className="btn-success" style={{ fontSize: "12px", paddingRight: '1px' }} onClick={handleModal}><Check size={21} />بله</Button>}
                {arrayBtn && arrayBtn.includes("no") && <Button className="btn-danger" style={{ fontSize: "12px", padding: '0.47rem 0.47rem' }} onClick={() => dispatch(setDialog({ status: 'hide' }))}><Cancel size={15} /> &nbsp;خیر</Button>}
                {arrayBtn && arrayBtn.includes("ok") && <Button style={{ fontSize: "12px" }} onClick={() => handleModal()}>باشه</Button>}
            </Modal.Footer>
        </Modal>
    )
}
export default ModalDialog;